<template>
  <div>
    <LDBsTable
      url="financial/contracts"
      defaultSort="id"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-6">
        <label for="contract">{{ $t("contract") }}</label>
        <Combobox
          class="bg-white"
          name="contract"
          :placeholder="$t('select_a_item')"
          :options="contracts"
          :initial-value="query.contract"
          label="contracts"
          v-model="query.contract"
          :reduce="(contract) => contract.id_contrato"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :initial-value="query.client"
          label="nome_cliente"
          v-model="query.client"
          :reduce="(client) => client.id"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="consultant">{{ $t("consultant") }}</label>
        <Combobox
          class="bg-white"
          name="consultant"
          :placeholder="$t('select_a_item')"
          :options="consultants"
          :initial-value="query.consultant"
          label="nome"
          v-model="query.consultant"
          :reduce="(consultant) => consultant.id"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="date_start_from">{{ $t("date_start") }} (De)</label>
        <input
          type="date"
          id="date_start_from"
          name="date_start_from"
          class="form-control"
          :placeholder="$t('ph_date_start')"
          v-model="query.dateStartFrom"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="date_start_to">{{ $t("date_start") }} (Até)</label>
        <input
          type="date"
          id="date_start_to"
          name="date_start_to"
          class="form-control"
          :placeholder="$t('ph_date_start')"
          v-model="query.dateStartTo"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="bloqueado_pagamento">Bloqueado Pagamento</label>
        <Combobox
          class="bg-white"
          name="bloqueado_pagamento"
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.bloqueado_pagamento"
          :options="booleanOptions"
          v-model="query.bloqueado_pagamento"
          :reduce="(active) => active.value"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="instalacao_junto_mensalidade"
          >Inst. Junto Mensalidade</label
        >
        <Combobox
          class="bg-white"
          name="instalacao_junto_mensalidade"
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.instalacao_junto_mensalidade"
          :options="booleanOptions"
          v-model="query.instalacao_junto_mensalidade"
          :reduce="(active) => active.value"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="retem_iss">Retém ISS</label>
        <Combobox
          class="bg-white"
          name="retem_iss"
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.retem_iss"
          :options="booleanOptions"
          v-model="query.retem_iss"
          :reduce="(active) => active.value"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="emitir_nfse">Emitir NFSe</label>
        <Combobox
          class="bg-white"
          name="emitir_nfse"
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.emitir_nfse"
          :options="booleanOptions"
          v-model="query.emitir_nfse"
          :reduce="(active) => active.value"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="dia_vencimento">{{ $t("due_day") }}</label>
        <input
          type="number"
          id="dia_vencimento"
          name="dia_vencimento"
          class="form-control"
          :placeholder="$t('ph_due_day')"
          v-model="query.dia_vencimento"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="dia_leitura">{{ $t("reading_day") }}</label>
        <input
          type="number"
          id="dia_leitura"
          name="dia_leitura"
          class="form-control"
          :placeholder="$t('ph_reading_day')"
          v-model="query.dia_leitura"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="isActive">{{ $t("active") }}</label>
        <Combobox
          class="bg-white"
          name="isActive"
          :placeholder="$t('select_a_item')"
          label="label"
          :initial-value="query.isActive"
          :options="booleanOptions"
          v-model="query.isActive"
          :reduce="(active) => active.value"
        />
      </div>
    </LDBsTable>

    <!-- MODAL ACTIVE/INACTIVE CONTRACT -->
    <div
      class="modal fade"
      id="modalActiveInactiveContract"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalActiveInactiveContractLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalActiveInactiveContractLabel">
              {{ dataToUpdate.ativo_contrato ? "Desativar" : "Ativar" }}
              contrato
              {{ dataToUpdate.id }}
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                CONTRATO:
                <strong>{{ dataToUpdate.codigo_externo_contrato }}</strong>
              </li>
              <li>
                CLIENTE:
                <strong>{{ dataToUpdate.nome_cliente }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="activeInactiveContract"
              :loading="isLoading"
            >
              {{
                $t(dataToUpdate.ativo_contrato ? "to_desactive" : "to_active")
              }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL BLOCK/UNBLOCK CONTRACT -->
    <div
      class="modal fade"
      id="modalBlockUnblockContract"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalBlockUnblockContractLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalBlockUnblockContractLabel">
              {{
                dataToUpdate.bloqueado_pagamento_contrato
                  ? "Desbloquear"
                  : "Bloquear"
              }}
              contrato
              {{ dataToUpdate.id }}
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                CONTRATO:
                <strong>{{ dataToUpdate.codigo_externo_contrato }}</strong>
              </li>
              <li>
                CLIENTE:
                <strong>{{ dataToUpdate.nome_cliente }}</strong>
              </li>
            </ul>

            <div
              class="form-group col-lg-6"
              v-if="dataToUpdate.liberado_atraso_pagamento"
              :class="{
                'has-error': errors.has('liberado_atraso_pagamento'),
              }"
            >
              <label for="liberado_atraso_pagamento"
                >Liberado atraso pagamento</label
              >
              <input
                type="date"
                id="liberado_atraso_pagamento"
                name="liberado_atraso_pagamento"
                class="form-control"
                :placeholder="$t('ph_liberado_atraso_pagamento')"
                v-model="dataToUpdate.liberado_atraso_pagamento"
                step="1"
              />

              <small
                v-show="errors.has('liberado_atraso_pagamento')"
                class="form-text text-muted"
              >
                {{ errors.first("liberado_atraso_pagamento") }}
              </small>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="blockUnblockContract"
              :loading="isLoading"
            >
              {{
                dataToUpdate.bloqueado_pagamento_contrato
                  ? "Desbloquear"
                  : "Bloquear"
              }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import { mapActions, mapState } from "vuex";
import { apiBaseUrl } from "@/lib/config";
import axios from "axios";
import LoaderButton from "@/components/button/LoaderButton.vue";
import {
  formatCurrency,
  formatBoolean,
  formatDate,
} from "../../../../lib/util";

export default {
  name: "FinancialContractList",

  components: {
    LDBsTable,
    Combobox,
    LoaderButton,
  },

  data() {
    return {
      columns: [
        {
          title: "Contrato",
          field: "codigo_externo_contrato",
          sortable: true,
        },
        {
          title: this.$t("client"),
          field: "nome_cliente",
          sortable: true,
        },
        {
          title: "Bloqueado (Pgto)",
          field: "bloqueado_pagamento_contrato",
          formatter: (value) => formatBoolean(value),
          sortable: true,
        },
        {
          title: "Valor Mensalidade",
          field: "valor_mensalidade",
          formatter: (value) => formatCurrency(value),
          sortable: false,
        },
        {
          title: "Dia Vencimento",
          field: "dia_vencimento",
          sortable: true,
        },
        {
          title: "Dia Leitura",
          field: "dia_leitura",
          sortable: true,
        },
        {
          title: "Dt. Início",
          field: "data_inicio",
          formatter: (value) => formatDate(value),
          sortable: true,
        },
        {
          title: "Inst. Junto Mensalidade",
          field: "instalacao_junto_mensalidade",
          formatter: (value) => formatBoolean(value),
          sortable: true,
          visible: false,
        },
        {
          title: "Retém ISS",
          field: "retem_iss",
          formatter: (value) => formatBoolean(value),
          sortable: true,
          visible: false,
        },
        {
          title: "Emitir NFSe",
          field: "emitir_nfse",
          formatter: (value) => formatBoolean(value),
          sortable: true,
          visible: false,
        },
        {
          title: "Consultor",
          field: "consultor_nome",
          sortable: false,
          visible: false,
        },
        {
          title: "Dias bloqueio",
          field: "dias_bloqueio",
          sortable: false,
          visible: false,
        },
        {
          title: "Valor Locação",
          field: "valor_locacao",
          formatter: (value) => formatCurrency(value),
          sortable: false,
          visible: false,
        },
        {
          title: "Valor Software",
          field: "valor_software",
          formatter: (value) => formatCurrency(value),
          sortable: false,
          visible: false,
        },
        {
          title: "Valor Telefonia",
          field: "valor_telefonia",
          formatter: (value) => formatCurrency(value),
          sortable: false,
          visible: false,
        },
        {
          title: "Valor Instalação",
          field: "valor_troca",
          formatter: (value) => formatCurrency(value),
          sortable: false,
          visible: false,
        },
        {
          key: "id",
          field: "id_contrato",
          align: "center",
          width: "120px",
          formatter: function (value, row) {
            let buttons = `
              <a
                title="Editar"
                href="#/main/financial/contract/${value}"
                class="
                  edit
                  btn
                  btn-action
                  btn-primary
                  btn-circle
                  light-bottom-shadow
                  text-white
                "
              >
                <i class="fas fa-pen" />
              </a>
            `;

            const isActive = row.ativo_contrato;
            const blocked = row.bloqueado_pagamento_contrato;

            buttons += `
              <button
                title="${isActive ? "Desativar" : "Ativar"} contrato"
                data-target="#modalActiveInactiveContract"
                data-id='${value}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-${
                  isActive ? "danger" : "success-green"
                } btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-${isActive ? "times" : "check"}" />
              </button>
            `;

            buttons += `
              <button
                title="${blocked ? "Desbloquear" : "Bloquear"} contrato"
                data-target="#modalBlockUnblockContract"
                data-id='${value}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-${
                  blocked ? "success-green" : "danger"
                } btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-${blocked ? "unlock" : "lock"}" />
              </button>
            `;

            return buttons;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "financial_contracts" },
      },
      queryToUse: {},
      query: {
        isActive: true,
        contract: "",
        client: "",
        bloqueado_pagamento: undefined,
        instalacao_junto_mensalidade: undefined,
        retem_iss: undefined,
        emitir_nfse: undefined,
        consultant: undefined,
        dia_leitura: "",
        dia_vencimento: "",
        dateStartFrom: "",
        dateStartTo: "",
      },
      dataToUpdate: {},
      booleanOptions: [
        { label: "SIM", value: true },
        { label: "NÃO", value: false },
      ],
    };
  },

  computed: {
    ...mapState({
      contracts: (state) => state.contracts.all,
      consultants: (state) => state.consultant.all,
      clients: (state) => state.financial.clients,
      lastquery: (state) => state.filtershistory.query,
      isLoading: (state) => state.contracts.isLoading,
      bstableData: (state) => state.bstable.all,
    }),
  },

  methods: {
    ...mapActions("contracts", [
      "activeContract",
      "inactiveContract",
      "blockContract",
      "unblockContract",
    ]),

    clear() {
      this.query.isActive = undefined;
      this.query.contract = "";
      this.query.client = "";
      this.query.bloqueado_pagamento = undefined;
      this.query.instalacao_junto_mensalidade = undefined;
      this.query.retem_iss = undefined;
      this.query.emitir_nfse = undefined;
      this.query.consultant = undefined;
      this.query.dateStartFrom = "";
      this.query.dateStartTo = "";
      this.query.dia_leitura = "";
      this.query.dia_vencimento = "";
    },

    async exportCSV() {
      const { dispatch } = this.$store;

      try {
        dispatch("overlay/show", true);

        const data = await axios.get(
          `${apiBaseUrl()}export-financial-contracts-csv`,
          { responseType: "blob" }
        );

        const url = window.URL.createObjectURL(
          new Blob([data.data])
        );
        const link = document.createElement("a");
        link.href = url;

        const contentDisposition = data.headers['content-disposition'];
        let filename = 'contratos_financeiro.xlsx';

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (filenameMatch.length > 1) {
            filename = filenameMatch[1];
          }
        }

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        dispatch("notify/error", { message: error }, { root: true });
      } finally {
        dispatch("overlay/show", false);
      }
    },

    async activeInactiveContract() {
      const { id, ativo_contrato } = this.dataToUpdate;

      ativo_contrato
        ? await this.inactiveContract(id)
        : await this.activeContract(id);

      $("#modalActiveInactiveContract").modal("hide");
      $("#search").trigger("click");
    },

    async blockUnblockContract() {
      const { id, bloqueado_pagamento_contrato, liberado_atraso_pagamento } =
        this.dataToUpdate;

      bloqueado_pagamento_contrato
        ? await this.unblockContract({
            id,
            data: { date: liberado_atraso_pagamento },
          })
        : await this.blockContract(id);

      $("#modalBlockUnblockContract").modal("hide");
      $("#search").trigger("click");
    },

    onShowModal(contractId) {
      this.errors.clear();

      const contract = this.bstableData.rows.find(
        (contract) => contract.id == contractId
      );

      this.dataToUpdate = contract;
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery["financialcontract"]
      ? this.lastquery["financialcontract"]
      : this.query;
  },

  async mounted() {
    const { dispatch } = this.$store;

    await Promise.all([
      dispatch("contracts/fetchAllContracts"),
      dispatch("financial/fetchClients"),
      dispatch("consultant/fetchAll"),
    ]);

    if (this.lastquery["financialcontract"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["financialcontract"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    const global = this;

    $("#modalActiveInactiveContract").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.onShowModal(button.data("id"));
    });

    $("#modalActiveInactiveContract").on("hide.bs.modal", function (event) {
      global.dataToUpdate = {};
    });

    $("#modalBlockUnblockContract").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.onShowModal(button.data("id"));
    });

    $("#modalBlockUnblockContract").on("hide.bs.modal", function (event) {
      global.dataToUpdate = {};
    });

    $("#toolbar").find("div:first").append(`
        <button
          id="export"
          class="btn btn-secondary right"
          aria-expanded="true"
        >
          <i class="fas fa-file-excel"></i>
        </button>
      `);

    $("#export").on("click", function () {
      global.exportCSV();
    });
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "financialcontract",
      query: this.query,
    });
  },
};
</script>
